module.exports = __webpack_public_path__ + "img/receiptone.00f85644.svg";